import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api } from '../client';
import { queryKeys } from './keys';
import type { DimensionInput, DimensionsConfig } from '../types';

export function useDimensions() {
  return useQuery({
    queryKey: queryKeys.dimensions,
    queryFn: () => api<DimensionsConfig>('/api/ideas/dimensions'),
  });
}

/** Saves the whole active matrix; dimensions left out are retired. */
export function useSaveDimensions() {
  const client = useQueryClient();
  return useMutation({
    meta: { success: 'Dimensions saved' },
    mutationFn: (body: { dimensions: DimensionInput[] }) =>
      api<DimensionsConfig>('/api/ideas/dimensions', 'PUT', body),
    onSuccess: (data) => {
      client.setQueryData(queryKeys.dimensions, data);
      // The matrix re-ranks every idea and changes its columns; a change the
      // prompt carries makes a new prompt version.
      void client.invalidateQueries({ queryKey: ['ideas'] });
      void client.invalidateQueries({ queryKey: queryKeys.processes });
      void client.invalidateQueries({ queryKey: queryKeys.promptVersions });
    },
  });
}
